import React, {Component} from 'react';
import './Default.css'
import objeler from '../objeler';

class Picture extends Component {
    constructor(props) {
        super(props);
        const {JpgBlob} = this.props;
        const inputRef = React.createRef(null);
        this.imgOnLoad = this.imgOnLoad.bind(this)
        this.imgRef = React.createRef();
    };

    componentDidMount() {
    }

    imgOnLoad() {
        const height = this.imgRef.current.naturalHeight
        const width = this.imgRef.current.naturalWidth
        const ElementProps = objeler['ElementProps'];
        // ✅ Guard: ElementProps is set when user clicks an element. Template apply
        // dispatches without click, so ElementProps may be undefined. Skip silently —
        // original dimensions aren't critical for rendering.
        if (!ElementProps) return;
        ElementProps.JpgOriginalWidth = width;
        ElementProps.JpgOriginalHeight = height;
        ElementProps.JpgOriginalAspectRatio = width / height;
        const {pictureOnLoad} = this.props;
        pictureOnLoad(ElementProps);
    }

    render() {
        const {file, content} = this.props;
        const imgstyle = {
            backgroundImage: "url(" + file + ")",
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        };
        return (<div id="tar" ref="tar" style={imgstyle}>
                <p>{content}</p>
                <img id={this.props.id + "img"} ref={this.imgRef} onLoad={this.imgOnLoad} rmimg={1}
                     style={{visibility: 'hidden'}}
                     src={file}></img>
            </div>
        );
    }
}

export default Picture;